export const collectionHeaders = [
    {
        "ordre": 1,
        "champ": "fournisseur.four_nom_aff",
        "label_champ": "Fournisseur",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 2,
        "champ": "modele.mod_descr",
        "label_champ": "Description",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 3,
        "champ": "departement.dept_nom",
        "label_champ": "Département",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 4,
        "champ": "categorie.cat_descr",
        "label_champ": "Catégorie",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 5,
        "champ": "prod_num",
        "label_champ": "Produit",
        "format_champ": "{0:0000000}",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 6,
        "champ": "act_cd",
        "label_champ": "Code Act",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 7,
        "champ": "prod_collection",
        "label_champ": "Collection",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 8,
        "champ": "stats.planost_ventes",
        "label_champ": "Ventes $",
        "format_champ": "{0:c}",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 9,
        "champ": "stats.planost_ventes_mcx",
        "label_champ": "Qté",
        "format_champ": "{0:n}",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 10,
        "champ": "stats.ventes_jr_p2",
        "label_champ": "$ P2 / Jr",
        "format_champ": "{0:c}",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    }
]